/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, ChangeEvent } from 'react'
import { Field, ErrorMessage, useFormikContext } from 'formik'

/**
 * Step 6_2 – Dati di fatturazione per ordini esistenti
 *
 * Raccolta dei campi collegati alla tabella `Contabilita`:
 *  • PDF Preventivo firmato (obbligatorio)
 *
 * NOTE
 *  • Al submit del wizard i file verranno inviati in un secondo
 *    step via `FormData` → POST /orders/:id/documents.
 *  • Il componente usa `useFormikContext` per settare il valore
 *    dei file nel formik state tramite `setFieldValue`.
 */

const Step6_2: FC = () => {
  const { setFieldValue } = useFormikContext<any>()

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>, fieldName: string) => {
    if (e.currentTarget.files && e.currentTarget.files[0]) {
      setFieldValue(fieldName, e.currentTarget.files[0])
    }
  }

  return (
    <div className='w-100'>
      <div className='pb-10 pb-lg-15'>
        <h2 className='fw-bolder text-dark'>Documentazione</h2>
        <div className='text-gray-400 fw-bold fs-6'>Inserisci i dati</div>
      </div>

      {/* Importo fattura */}
      {/*<div className='fv-row mb-10'>
        <label htmlFor='Importo_fattura' className='form-label required'>
          Importo fattura (€)
        </label>
        <Field
          type='number'
          id='Importo_fattura'
          name='Importo_fattura'
          step='0.01'
          min='0'
          className='form-control form-control-lg form-control-solid'
        />
        <div className='text-danger mt-2'>
          <ErrorMessage name='Importo_fattura' />
        </div>
      </div>*/}

      {/* Preventivo firmato PDF */}
      <div className='fv-row mb-10'>
        <label htmlFor='Preventivo_firmato' className='form-label required'>
          Preventivo firmato (PDF) (max 5MB)
        </label>
        <input
          id='Preventivo_firmato'
          name='Preventivo_firmato'
          type='file'
          accept='application/pdf'
          className='form-control form-control-lg form-control-solid'
          onChange={(e) => handleFileChange(e, 'Preventivo_firmato')}
        />
        <div className='text-danger mt-2'>
          <ErrorMessage name='Preventivo_firmato' />
        </div>
      </div>
    </div>
  )
}

export { Step6_2 }